import { formatAction } from "@/lib/formatter/actions";
import { getActionById } from "@/pages/admin/rules/actions/lib/queries";
import {
  DataGrid,
  DataGridLabel,
  DataGridRow,
  DataGridValue,
} from "@/components/common/dataGrid";
import { useEffect, useState } from "react";

export const ActionShow = ({ id }) => {
  const [action, setAction] = useState(null);

  const fetchAction = async () => {
    setAction(await getActionById(id));
  };

  useEffect(() => {
    fetchAction();
  }, [id]);

  if (!action) {
    // TODO implement not found
    // notFound();
    return null;
  }

  const actionFormatted = formatAction(action);

  return (
    <DataGrid>
      <DataGridRow>
        <DataGridLabel>Rule</DataGridLabel>
        <DataGridValue>{actionFormatted?.rule}</DataGridValue>
      </DataGridRow>
      <DataGridRow>
        <DataGridLabel>Actie type</DataGridLabel>
        <DataGridValue>{actionFormatted?.ruleActionType}</DataGridValue>
      </DataGridRow>
      <DataGridRow>
        <DataGridLabel>Naam</DataGridLabel>
        <DataGridValue>{actionFormatted?.name}</DataGridValue>
      </DataGridRow>
      <DataGridRow>
        <DataGridLabel>Omschrijving</DataGridLabel>
        <DataGridValue>{actionFormatted?.description}</DataGridValue>
      </DataGridRow>
      <DataGridRow>
        <DataGridLabel>Data</DataGridLabel>
        <DataGridValue>{actionFormatted?.data}</DataGridValue>
      </DataGridRow>
      <DataGridRow>
        <DataGridLabel>Prioriteit</DataGridLabel>
        <DataGridValue>{actionFormatted?.priority}</DataGridValue>
      </DataGridRow>
      <DataGridRow>
        <DataGridLabel>Actief</DataGridLabel>
        <DataGridValue>{actionFormatted?.active}</DataGridValue>
      </DataGridRow>
      <DataGridRow>
        <DataGridLabel>Vertraging (sec)</DataGridLabel>
        <DataGridValue>{actionFormatted?.delayInSeconds}</DataGridValue>
      </DataGridRow>
      <DataGridRow>
        <DataGridLabel>Synchroon</DataGridLabel>
        <DataGridValue>{actionFormatted?.synchronous}</DataGridValue>
      </DataGridRow>
    </DataGrid>
  );
};
